// import { produce } from 'immer/dist/immer.umd.production.min.js';
import { produce } from "immer";
import { EditMode } from "../state/uiState";
export function pane_setTranslation(machineState, translation) {
    return produce(machineState, draftState => {
        draftState.uiState.pane.translation = translation;
    });
}
export function pane_setScale(machineState, scale) {
    return produce(machineState, draftState => {
        draftState.uiState.pane.scale = scale;
    });
}
export function pane_setShowParameters(machineState, scale, translation) {
    return produce(machineState, draftState => {
        draftState.uiState.pane.scale = scale;
        draftState.uiState.pane.translation = translation;
    });
}
// actions - uiState
// export const startDrag = (state: State, dragOffset: Vector, stateIdToDragId: string): State => {
//     return produce(state, draftState => {
//         const draftUiState = draftState.machineState.uiState;
//         draftUiState.editMode = EditMode.DRAGGING_STATE;
//         draftUiState.dragState.dragOffset = dragOffset;
//         draftUiState.dragState.stateId = stateIdToDragId;
//         draftUiState.dragState.dragged = false;
//     });
// }
// export const setMouseMovedInDrag = () => (draftState: UiState) => {
//     draftState.dragState.dragged = true;
// }
// export const removeMouseMovedInDrag = () => (draftState: UiState) => {
//     draftState.dragState.dragged = false;
// }
// export const stopDrag = () => (draftState: UiState) => {
//     draftState.editMode = EditMode.NEUTRAL;
// }
// export const showStateOptionsDialog = (stateId: string) => (draftState: UiState) => {
//     draftState.stateOptionsDialog.showDialog = true;
//     draftState.stateOptionsDialog.stateId = stateId;
// }
// export const hideStateOptionsDialog = () => (draftState: UiState) => {
//     draftState.stateOptionsDialog.showDialog = false;
//}
export function select_node(machineState, stateId) {
    return produce(machineState, draftState => {
        draftState.uiState.selection = { stateId: stateId };
    });
}
export function select_deselect(machineState) {
    return produce(machineState, draftState => {
        draftState.uiState.selection = {};
    });
}
export function showTransitionOptionsDialog(state, transitionId) {
    return produce(state, draftState => {
        // draftState.uiState.transitionOptionsDialog.showDialog = true;
        // draftState.uiState.transitionOptionsDialog.transitionId = transitionId;
        draftState.machineState.uiState.selection = { transitionId: transitionId };
    });
}
export function setEditMode(state, editMode) {
    return produce(state, draftState => {
        draftState.machineState.uiState.editMode = editMode;
    });
}
export function startAddTransition(state) {
    return produce(state, draftState => {
        draftState.machineState.uiState.editMode = EditMode.ADD_TRANSITION;
        draftState.machineState.uiState.addTransition.fromNodeId = undefined;
    });
}
export function setAddTransitionFromNodeId(state, nodeId) {
    return produce(state, draftState => {
        draftState.uiState.addTransition.fromNodeId = nodeId;
    });
}
export function fullscreen_toggle(state) {
    return produce(state, draftState => {
        draftState.fullscreen = !draftState.fullscreen;
    });
}
